import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { Link as RouterLink, useLocation } from 'react-router';
import { EmptyState, PageHeader, Section } from '../shared/ui/page';

/** An address the application does not have: said plainly, inside the shell, with a way back. */
export function NotFoundPage() {
  const location = useLocation();
  return (
    <Stack spacing={3}>
      <PageHeader title="Page not found" />
      <Section>
        <EmptyState
          title="There is no page at this address"
          detail={`${location.pathname} does not exist. Use the menu, or go back to the dashboard.`}
        />
        <Stack sx={{ alignItems: 'center', pb: 4 }}>
          <Button component={RouterLink} to="/" variant="contained">
            Go to the dashboard
          </Button>
        </Stack>
      </Section>
    </Stack>
  );
}
